import './decision-summary-table.css';

import { List } from '@kerfjs/ui/list';
import { Text } from '@kerfjs/ui/text';
import type { SafeHtml } from 'kerfjs';

import type { DecisionSummaryT } from '../../../data/api.js';
import { DecisionBadge } from '../../decision-badge.js';
import { EdgeToEdgeTable } from '../../edge-to-edge-table.js';
import { VERDICT_LABELS } from '../../verdict-chip.js';

/** Scrollable business-office table with a sticky header and combined Item column. */
export function DecisionSummaryTable({ summary }: { summary: DecisionSummaryT }): SafeHtml {
  return (
    <EdgeToEdgeTable label="Decision Summary Table" bounded>
      <table class="t decision-summary-grid">
        <thead>
          <tr>
            <th class="decision-summary-item">Item</th>
            <th class="n">Qty</th>
            <th>Verdict</th>
            <th>Decision</th>
            <th class="n">Price / target</th>
            <th>Vendor</th>
            <th>Reason</th>
            <th>Note</th>
          </tr>
        </thead>
        <tbody>
          {summary.lines.map((line) => (
            <tr data-key={String(line.lineNumber)}>
              <td class="decision-summary-item">
                <span class="decision-summary-item-content">
                  <span class="decision-summary-line-number">{String(line.lineNumber)}.</span>
                  <span>{line.description}</span>
                </span>
              </td>
              <td class="n">
                {line.quantity ?? null} {line.unit ?? null}
              </td>
              <td>
                {line.verdict !== null ? (
                  <List>
                    <Text variant="span">{VERDICT_LABELS[line.verdict] ?? line.verdict}</Text>
                    {line.analysisVersion !== null ? (
                      <Text variant="span" tone="quiet" size="compact">
                        Pricing check v{String(line.analysisVersion)}
                        {line.benchmarkLow !== null && line.benchmarkHigh !== null
                          ? ` · ${line.benchmarkCurrency ?? summary.base} ${line.benchmarkLow}–${line.benchmarkHigh}`
                          : null}
                      </Text>
                    ) : null}
                  </List>
                ) : (
                  '—'
                )}
              </td>
              <td>
                {line.action !== null ? (
                  <DecisionBadge action={line.action} />
                ) : (
                  <Text variant="span" tone="quiet">
                    pending
                  </Text>
                )}
              </td>
              <td class="n">{line.approvedUnitPrice ?? line.targetPrice ?? '—'}</td>
              <td>{line.vendorName ?? null}</td>
              <td>
                <Text variant="span" tone="quiet" size="compact">
                  {line.selectionReason !== null && line.selectionReason !== ''
                    ? `not lowest: ${line.selectionReason}`
                    : null}
                </Text>
              </td>
              <td>
                <Text variant="span" tone="quiet" size="compact">
                  {line.note ?? null}
                </Text>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </EdgeToEdgeTable>
  );
}
